var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"err_page"},[_c('div',{staticClass:"body"},[_c('img',{attrs:{"src":require("../../../../assets/refund/ic_wangluo@2x.png"),"alt":""}}),_c('p',{staticClass:"title"},[_vm._v("网络异常")]),_c('p',{staticClass:"content"},[_vm._v("请检查网络连接情况后再试")])])])
}]

export { render, staticRenderFns }